var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-0.0381851 5.9194C-0.0381851 5.70722 0.0583048 5.49507 0.250895 5.3333L6.31423 0.242863C6.69993 -0.0809545 7.32529 -0.0809545 7.71084 0.242863C8.09639 0.566552 8.09639 1.09146 7.71084 1.41531L2.34566 5.9194L7.71066 10.4235C8.0962 10.7473 8.0962 11.2722 7.71066 11.5959C7.32511 11.9198 6.69975 11.9198 6.31404 11.5959L0.250695 6.50548C0.0580854 6.34363 -0.0381851 6.13149 -0.0381851 5.91939V5.9194Z",
    fill: "#222B45"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoLeft);
export default __webpack_public_path__ + "static/media/ico-left.7e1b85fe3d7221dfa541f5646408ea70.svg";
export { ForwardRef as ReactComponent };